import Vue from 'vue'
import './plugins/axios'
import './plugins/fontawesome'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.js'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Toasted from 'vue-toasted';
import SocialSharing from 'vue-social-sharing';
import VueClipboard from 'vue-clipboard2'
import VueQrcodeReader from 'vue-qrcode-reader'
import NProgress from 'vue-nprogress'
import './registerServiceWorker'
import Components from './components';
import './mixin/mixins';
import VueAnalytics from 'vue-analytics';

window.EventBus = new Vue();
Vue.config.productionTip = false;

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);
});

Vue.use(VueQrcodeReader);
Vue.use(NProgress,{latencyThreshold:0,router:true,http:true});
Vue.use(Toasted);
Vue.use(SocialSharing);
Vue.use(VueClipboard);
Vue.use(VueAnalytics, 
{
	id: 'UA-142874841-1',
	router
})

const nprogress = new NProgress();

new Vue({
  nprogress,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

